import { z } from "zod"
import { paginatedResponseSchema, apiResponseSchema } from "./shared"

export const campaignStatusSchema = z.enum([
  "DRAFT",
  "PENDING_PAYMENT",
  "PENDING_APPROVAL",
  "REJECTED",
  "ACTIVE",
  "PAUSED",
  "ENDED",
  "CANCELLED",
])

export const campaignSchema = z
  .object({
    _id: z.string(),
    name: z.string().optional(),
    status: campaignStatusSchema.optional(),
    image: z.string().optional(),
    creatives: z
      .array(
        z
          .object({
            image: z.string().optional(),
            videoUrl: z.string().optional(),
            mediaType: z.enum(["image", "video"]).optional(),
            variantId: z.string().optional(),
            weight: z.number().optional(),
          })
          .passthrough()
      )
      .optional(),
    service: z
      .union([
        z.string(),
        z.number(),
        z.object({ _id: z.string().optional(), name: z.string().optional() }).passthrough(),
      ])
      .optional(),
    advertisementPlan: z
      .union([
        z.string(),
        z.object({
          _id: z.string().optional(),
          name: z.string().optional(),
          price: z.number().optional(),
          duration: z.number().optional(),
          durationUnit: z.string().optional(),
        }).passthrough(),
      ])
      .optional(),
    approved: z.boolean().optional(),
    paid: z.boolean().optional(),
    paused: z.boolean().optional(),
    rejectionReason: z.string().optional(),
    payoutPaid: z.string().optional(),
    clicks: z.number().optional(),
    views: z.number().optional(),
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    business: z
      .union([
        z.string(),
        z.object({
          _id: z.string().optional(),
          name: z.string().optional(),
        }).passthrough(),
      ])
      .optional(),
  })
  .passthrough()

export const campaignMetricsSchema = z.object({}).passthrough()

export const campaignSummarySchema = z.object({
  pendingApproval: z.number(),
  active: z.number(),
  monthlyRevenue: z.number(),
})

export const campaignsResponseSchema = paginatedResponseSchema(campaignSchema)
export const campaignResponseSchema = apiResponseSchema(campaignSchema)
export const campaignMetricsResponseSchema = apiResponseSchema(campaignMetricsSchema)
export const campaignSummaryResponseSchema = apiResponseSchema(campaignSummarySchema)
